// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function() {
    // Get the Contact link element
    var contactLink = document.querySelector('.nav-link[href="#consult"]');

    // Get the button element
    var closeButton = document.querySelector('.btn-close');

    // Add click event listener
    contactLink.addEventListener('click', function(e) {

        // Check if offcanvas has the class 'show'
        var offcanvas = document.querySelector('.offcanvas');
        var isOffcanvasVisible = offcanvas.classList.contains('show');

        // Toggle the button visibility
        if (isOffcanvasVisible) {
            closeButton.classList.toggle('d-none');

            // Trigger a click event on the button
            closeButton.click();
        }
    });
});